<template>
  <div>
    <van-popup v-model="showPopup" @close="close">
      <div class="game_bind">
        <div class="game_bind_title">
          <div class="game_bind_title_text">当前手机暂未注册游戏账号</div>
          <div class="game_bind_title_text1">为了您的账号安全，请先绑定游戏账号</div>
        </div>
        <div class="game_bind_content">
          <div class="input_box" style="margin-top: 1rem;">
            <input type="phone" autocomplete="new-password" class="my_input" placeholder-style="color:#8E8E8E" placeholder="请输入游戏账号" maxlength="" v-model="info.phone" @input="isInput" ref="phoneInput">
            <div class="input_Box_closeA" v-if="showClearIcon" @click="clearIcon">
              <img src="@/assets/image/icon/loginClose.png">
            </div>
          </div>
          <div class="input_box" style="margin-top: .75rem;">
            <input maxlength="" autocomplete="new-password" :type="passwordShow ? 'text' : 'password'" v-model="info.password" placeholder="请输入密码" placeholder-style="color:#8E8E8E" class="my_input" />
            <div class="input_Box_close" v-if="info.password.length > 0" @click="passwordShow = !passwordShow">
              <img class="image_show" v-if="passwordShow" src="@/assets/image/set/password1.png">
              <img v-else class="image_hide" src="@/assets/image/set/password2.png">
            </div>
          </div>
          <div class="game_bind_btn">
            <single-button v-if="!isBind" width="10.9rem" height="1.7rem" :background="!isBind && '#8e8e8e'" color="#fff" text="绑定" marginTop="1.25rem"></single-button>
            <single-button v-else @know="bind" width="10.9rem" height="1.7rem" color="#FFDB89" text="绑定" marginTop="1.25rem"></single-button>
            <div :style="{
              color: skiptime > 0 ? '#8e8e8e' : '#666666'
            }" class="skip_bind" @click="skipBind">
              跳过绑定，自动创建游戏账号 <span v-if="skiptime > 0">( {{skiptime}}s )</span>
            </div>
          </div>
        </div>
      </div>
      <div class="tcclose" @click="close">
        <img src="@/assets/image/icon/tcclose.png" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import tokenUtil from '@/utils/token'
export default {
  name: 'UniMailiangGameBind',

  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {}
  },

  computed: {
    isBind(){
      return this.info.phone && this.info.password
    },
	  wulinShareParams() {
	    return this.$store.state.activity.wulinShareParams
	  }
  },

  data() {
    return {
      showPopup: false,
      passwordShow: false,
      showClearIcon: false,
      info: {
        password: "",
        phone: "",
      },
      skiptime: 5,
      skiptimer: null
    };
  },

  async mounted() {
    
  },

  methods: {
    async bind() {
      console.log(this.info);
      if(!this.info.phone||!this.info.password) {
        this.$toast('请输入账号密码')
        return
      }
      const res =  await this.$ajax('/Authority/bindAccount', {
        phone: this.data.phone,
        username: this.info.phone,
        password: this.info.password,
        register_password: this.data.register_password,
        ...this.wulinShareParams
      })
      if(res.code == 200) {
        this.$toast('绑定成功')
        this.$loginPopup(false)
        if(this.data.func)this.data.func()
        tokenUtil.save(res.data.accessToken);
        this.$store.dispatch('getUserInfo');
        this.close()
      } else{
        this.$toast(res.msg)
      }
    },
    async skipBind() {
      if (this.skiptime > 0) return
      const res =  await this.$ajax('/Authority/bindAccount', {
        phone: this.data.phone,
        type: '1',
        register_password: this.data.register_password,
        ...this.wulinShareParams
      })
      if(res.code == 200) {
        this.$toast('创建成功')
        this.$loginPopup(false)
        if(this.data.func)this.data.func()
        tokenUtil.save(res.data.accessToken);
        this.$store.dispatch('getUserInfo');
        this.close()
      } else {
        this.$toast(res.msg)
      }
    },
    isInput(e) {
      if (e.target.value.length > 0) {
        this.showClearIcon = true;
      } else {
        this.showClearIcon = false;
      }
      if (e.target.value.length == 0) {
        this.showBtn = 0;
        this.showClearIcon = false;
      }
    },
    close() {
      this.showPopup = false
      this.$store.commit('popup/setPagePopupData', {})
      this.skiptime = 5
      this.info = {
        password: "",
        phone: "",
      }
      this.passwordShow = false
      this.showClearIcon = false
      clearInterval(this.skiptimer)
    },
    clearIcon() {
      this.info.phone = "";
      this.showBtn = 0;
      this.showClearIcon = false;
    },
  },

  watch: {
    open(val) {
      console.log(val);
      if (val) {
        this.showPopup = true
        this.skiptimer = setInterval(() => {
          if (this.skiptime > 0) {
            this.skiptime--
          }
        }, 1000)
      } else {
        this.showPopup = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  border-radius: .5rem;
}

.game_bind {
  width: 15.5rem;
  height: 14.5rem;
  background: #ffffff;
  border-radius: .5rem .5rem .5rem .5rem;
  padding: 0 1.35rem;
  .game_bind_title {
    padding-top: 1.2rem;
    .game_bind_title_text {
      font-size: .9rem;
      font-weight: 700;
      color: #1d1d1d;
    }
    .game_bind_title_text1 {
      font-size: .6rem;
      font-weight: 400;
      color: #8e8e8e;
      margin-top: .1rem;
    }
  }
  .input_box {
    width: 12.5rem;
    height: 1.8rem;
    background: #F2F2F2;
    border-radius: .25rem .25rem .25rem .25rem;
    display: flex;
    align-items: center;
    color: #1d1d1d;
    padding: 0 .5rem;
    input{
      font-size: .7rem;
      background: transparent;
      border: none;
      outline: none;
    }

    .placeholder-class {
      font-size: .8rem;
    }

    .input_Box_close {
      width: 2.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: .25rem;

      .image_close {
        display: block;
        width: .6rem;
        height: .6rem;
      }

      .image_show {
        display: block;
        width: .6rem;
        height: .6rem;
      }

      .image_hide {
        display: block;
        width: .6rem;
        height: .6rem;
      }
    }

    .my_input {
      width: 8.5rem;
      color: #1d1d1d;
      font-size: .8rem;
      flex: 1;
    }

    .input_Box_closeA {
      width: 2.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: .25rem;

      img {
        display: block;
        width: .6rem;
        height: .6rem;
      }
    }
  }
  .game_bind_btn{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .skip_bind{
    font-size: .6rem;
    color: #CACACA;
    margin-top: .65rem;
  }
}
.tcclose {
  position: absolute;
  bottom: -2rem;
  left: 50%;
  transform: translateX(-50%);
  img {
    width: .93rem;
    height: .93rem;
  }
}
</style>